/*! Lazy Image */
class LazyImage extends HTMLImageElement {
  constructor() {
    super();

    this.wrapper = this.closest('.media-wrapper');
    if (this.wrapper === null) return;

    this.lastSrc = this.currentSrc || this.getAttribute('src') || '';
    this.lastSrcset = this.getAttribute('srcset') || '';
    this.onImageLoad = this.onImageLoad.bind(this);
    this.onImageError = this.onImageError.bind(this);

    this.handleLazy();
    addEventListener('resize', this.handleLazy.bind(this), true);

    const observer = new MutationObserver((changes) => {
      changes.forEach((change) => {
        if (change.attributeName.includes('src') || change.attributeName.includes('srcset')) {
          const nextSrc = this.currentSrc || this.getAttribute('src') || '';
          const nextSrcset = this.getAttribute('srcset') || '';
          const sourceChanged = nextSrc !== this.lastSrc || nextSrcset !== this.lastSrcset;

          if (sourceChanged) {
            this.classList.remove('loaded');
            this.lastSrc = nextSrc;
            this.lastSrcset = nextSrcset;
          }

          this.handleLazy();
        }
      });
    });
    observer.observe(this, {attributes : true});
  }

  isHiddenByBreakpoint() {
    const mqlTablet = window.matchMedia('(min-width: 750px)');

    if (mqlTablet.matches && this.classList.contains('medium-hide')) return true;
    if (!mqlTablet.matches && this.classList.contains('small-hide')) return true;

    return false;
  }

  isDesktopHoverSecondary() {
    return !window.matchMedia('(min-width: 990px)').matches && this.closest('.second-image') !== null;
  }

  shouldAffectWrapperLoading() {
    if (this.isHiddenByBreakpoint()) return false;
    if (this.isDesktopHoverSecondary()) return false;

    return true;
  }

  syncWrapperLoadingState() {
    if (!this.wrapper) return;

    const images = Array.from(this.wrapper.querySelectorAll('img[is="lazy-image"]'));
    const hasPendingRelevantImage = images.some((image) => {
      if (typeof image.shouldAffectWrapperLoading === 'function' && !image.shouldAffectWrapperLoading()) {
        return false;
      }

      return !(image.complete && image.naturalWidth > 0) && !image.classList.contains('loaded');
    });

    this.wrapper.classList.toggle('loading', hasPendingRelevantImage);
  }

  markLoaded() {
    this.classList.add('loaded');
    this.syncWrapperLoadingState();
  }

  onImageLoad() {
    const loaded = () => {
      this.markLoaded();
      this.lastSrc = this.currentSrc || this.getAttribute('src') || '';
      this.lastSrcset = this.getAttribute('srcset') || '';
    };

    window.requestIdleCallback ? window.requestIdleCallback(loaded, {timeout: 150}) : setTimeout(loaded);
  }

  onImageError() {
    this.classList.add('loaded');
    this.syncWrapperLoadingState();
  }

  handleLazy () {
    if (!this.shouldAffectWrapperLoading()) {
      this.syncWrapperLoadingState();
      return;
    }

    if (this.complete && this.naturalWidth > 0) {
      this.markLoaded();
      return;
    }

    if (this.classList.contains('loaded')) {
      this.syncWrapperLoadingState();
      return;
    }

    this.syncWrapperLoadingState();
    this.removeEventListener('load', this.onImageLoad);
    this.removeEventListener('error', this.onImageError);
    this.addEventListener('load', this.onImageLoad, { once: true });
    this.addEventListener('error', this.onImageError, { once: true });
  }
}
window.customElements.define('lazy-image', LazyImage, { extends: 'img' });

class ProgPicture extends HTMLPictureElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.addEventListener('touchmove', this.touchmove_handler, { signal: this.abortController.signal });
  }

  touchmove_handler(ev) {
    if (ev.scale > 1) {
      var hqImage = this.getAttribute('data-hq');
      this.querySelector('source').setAttribute('srcset', hqImage);
      this.abortController.abort();
    }
  }
}
window.customElements.define('prog-picture', ProgPicture, { extends: 'picture' });
